<template>
  <el-drawer  
    class="drawer" 
    id="image_drawer" 
    :withHeader="false" 
    :show-close="false" 
    :destroy-on-close="true" 
    :visible.sync="isVisible" 
    size="101%"
    direction="btt"
  >
    <el-row class="fs-site">
      <el-row class="fs-entry-header">
        <el-col :span="4" class="fs-close" @click.native="closePage">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </el-col>
        <el-col :span="16" class="text-center">
          <h2>{{ $t('pageOrderMoreImage.seemore') }}</h2>
        </el-col>
      </el-row>
      <el-row class="overflow-auto min-90h">
        <template v-for="(url,index) in urls">
          <el-col v-if="(index+1)%2==1" :span="12" class="relative r-col-border-2-l" :key="'moreurlimg'+index">
              <div class="r-gallery">
                  <el-image :src="url" :fit="'cover'" :preview-src-list="urls" lazy></el-image>
              </div>
          </el-col>
          <el-col v-if="(index+1)%2==0" :span="12" class="relative r-col-border-2-r" :key="'moreurlimg'+index">
              <div class="r-gallery">
                  <el-image :src="url" :fit="'cover'" :preview-src-list="urls" lazy></el-image>
              </div>
          </el-col>
        </template>
      </el-row>
    </el-row>

  </el-drawer>
</template>

<script>
export default {
  props: {
    value: { default: false },
    images: { default: () => ([]) },
  },
  methods: {
    close_page() {
      this.isVisible = false;
    },
    viewDetail(branch,index) {
      branch.view = !branch.view
      this.$set(this.branches,index,branch)
    },
    isOnlyOneFlag (branch) {
      return (+branch.delivery_flag+ +branch.pickup_flag) == 2
    },
    closePage() {
      this.$emit('toggle_all_image')
    }
  },
  computed: {
    isVisible: {
      get: function() {
        return this.value
      },
      set: function(value) {
        this.$emit('input', value)
      }
    },  
    urls() {
      return this.images.map(item => {
        return 'https://images.foodstory.co/'+item.restaurant_image_key
      })
    },
  },
};

</script>




// WEBPACK FOOTER //
// src/components/restaurant/RestauranMoreImage.vue